export const FETCH_MODULE_CONFIGURATION = 'FETCH_MODULE_CONFIGURATION';
export const FETCH_MODULE_CONFIGURATION_SUCCESS = 'FETCH_MODULE_CONFIGURATION_SUCCESS';

export const CLEAR_MODULE_CONFIGURATION = 'CLEAR_MODULE_CONFIGURATION';